export default "__VITE_ASSET__C9UxSgdj__"